export const set_tenant = 'set_tenant' // 门店信息
export const set_navindex = 'set_navindex' // 全局一级菜单
export const set_second = 'set_second' // 全局二级菜单
export const get_DictOptions = 'get_DictOptions' // dict/list接口请求
export const set_listDatas = 'set_listDatas' // dict/list接口请求
export const set_permissionlist = 'set_permissionlist' // dict/list接口请求
export const set_childIndex = 'set_childIndex'
export const set_claerListDatas = 'set_claerListDatas' // 清空
export const set_globalmenulist = 'set_globalmenulist'
export const set_updateServerTime = 'set_updateServerTime' // 更新服务器时间

export const set_remaind_price = 'setRemaindPrice' // 更新次卡余额



// WEBPACK FOOTER //
// ./src/store/mutations-type.js